import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { id: Number, type: String };

  connect() {
    this.originalText = this.element.textContent.trim();
  }

  edit() {
    if (this.element.querySelector("form")) return;

    const defaultText = "Klicken, um eine Notiz zu hinterlegen...";
    const currentText = this.originalText === defaultText ? "" : this.originalText;
    const updateUrl = `/admin/remarks/update`;

    this.element.innerHTML = `
      <form action="${updateUrl}" method="post" data-turbo-frame="remark_${this.typeValue.toLowerCase()}_${this.idValue}" class="editable-form">
        <input type="hidden" name="_method" value="patch"> 
        <input type="hidden" name="remarkable_id" value="${this.idValue}">
        <input type="hidden" name="remarkable_type" value="${this.typeValue}">
        <textarea name="remark" class="editable-textarea w-full">${currentText}</textarea>
        <div class="editable-buttons">
          <button type="submit" class="px-2 py-1 rounded bg-red-500 text-white">Speichern</button>
          <button type="button" class="px-2 py-1 rounded bg-gray-100 cancel-button">Abbrechen</button>
        </div>
      </form>
    `;

    const textarea = this.element.querySelector("textarea");
    textarea.focus();
    textarea.selectionStart = textarea.selectionEnd = textarea.value.length;
    textarea.addEventListener("keydown", (event) => this.handleKeydown(event));

    this.element.querySelector(".cancel-button").addEventListener("click", (event) => this.cancel(event));
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.element.querySelector("form").requestSubmit();
    } else if (event.key === "Escape") {
      this.cancel(event);
    }
  }

  cancel(event) {
    event.preventDefault();

    const newElement = document.createElement("div");
    newElement.innerHTML = this.originalText;
    newElement.className = this.element.className;
    newElement.setAttribute("data-controller", "editable");
    newElement.setAttribute("data-action", "click->editable#edit");
    newElement.setAttribute("data-editable-id-value", this.idValue);
    newElement.setAttribute("data-editable-type-value", this.typeValue);

    this.element.replaceWith(newElement);
  }
}
